import MaterialSnackbar from '@material-ui/core/Snackbar';
import React, { PureComponent } from 'react';
import SnackbarContentWrapper from './SnackbarContentWrapper';
import ThemeWrap from './ThemeWrap';

type SnackbarProps = {
  open: boolean;
  autoHideDuration?: number | null;
  message: string;
  variant: string;
};

type SnackbarState = {
  open: boolean;
};

export default class Snackbar extends PureComponent<
  SnackbarProps,
  SnackbarState
> {
  constructor(props: SnackbarProps) {
    super(props);

    this.state = {
      open: props.open || false,
    };
  }

  close = () => {
    // Prevent a re-render for happening when the snackbar is already closed.
    // Someone may call close on a snackbar that has an autoHideDuration that
    // has already completed.
    if (this.state.open === true) {
      this.setState({ open: false });
    }
  };

  render() {
    const { message, variant = 'info', autoHideDuration } = this.props;

    const { open } = this.state;

    return (
      <ThemeWrap>
        <MaterialSnackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={open}
          autoHideDuration={autoHideDuration}
          onClose={this.close}
        >
          <SnackbarContentWrapper
            className="lo-snackbar-content"
            onClose={this.close}
            variant={variant}
            message={message}
          />
        </MaterialSnackbar>
      </ThemeWrap>
    );
  }
}
